var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0257111,
    width: 44,
    height: 44,
    rx: 8,
    fill: "#516F90"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0293 22.4584L21.5847 18.0137L26.0293 13.5693L30.4737 18.0137L26.0293 22.4584ZM14.627 20.9527V14.6527H20.927V20.9527H14.627ZM23.073 29.3987V23.0987H29.373V29.3987H23.073ZM14.627 29.3987V23.0987H20.927V29.3987H14.627ZM15.977 19.6027H19.577V16.0027H15.977V19.6027ZM26.0518 20.5787L28.5943 18.0362L26.0518 15.4937L23.5093 18.0362L26.0518 20.5787ZM24.423 28.0487H28.023V24.4487H24.423V28.0487ZM15.977 28.0487H19.577V24.4487H15.977V28.0487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13 13.0257)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsactive);
export default __webpack_public_path__ + "static/media/assetsactive.5121f4a50effedce308cbd65036b6fd4.svg";
export { ForwardRef as ReactComponent };